export default "__VITE_ASSET__C5$jfMzD__"